import type { IAddinCommand } from 'owa-addins-types';
import type Addin from '../store/schema/Addin';
import { owaComputedFn } from 'owa-computed-fn';

/**
 * This function retrieves the group label, command label, provider, and type string for a specific add-in.
 * @param addin addin to get metadata for
 * @returns An object containing groupLabel, commandLabel, commandCount, provider, typeString, name, or undefined if not found
 */
export const getAddinGroupMetadataFromAddin: (addin: Addin | undefined) =>
    | {
          groupLabel?: string;
          commandLabel?: string;
          commandCount: number;
          providerName?: string;
          typeString?: string;
          name?: string;
      }
    | undefined = owaComputedFn(
    (
        addin: Addin | undefined
    ):
        | {
              groupLabel?: string;
              commandLabel?: string;
              commandCount: number;
              providerName?: string;
              typeString?: string;
              name?: string;
          }
        | undefined => {
        if (addin) {
            const addinCommands = addin.AddinCommands as Map<string, IAddinCommand>;
            const commandCount = addinCommands.size;
            for (const command of addinCommands.values()) {
                const groupLabel = command.get_GroupLabel?.() ?? undefined;
                const commandLabel = command.get_Label?.() ?? undefined;
                const providerName = command.get_ProviderName?.() ?? undefined;
                const typeString = command.get_TypeString?.() ?? undefined;
                const name = command.get_ExtensionDisplayName?.() ?? undefined;
                return {
                    groupLabel,
                    commandLabel,
                    commandCount,
                    providerName,
                    typeString,
                    name,
                };
            }
        }
        return undefined;
    }
);
